import React, { PropsWithChildren } from 'react';
import { ConfigStore } from '~/stores/config.store';
import { INetworkStore } from '~/types/dependency.types';
import { User } from '~/models/user.model';
import { Company } from '~/models/company.model';
import useStatsigProviderProps from '~/common/Statsig/useStatsigProviderProps';
import { StatsigProvider } from 'statsig-react';
import { observer } from 'mobx-react';

export type HBStatsigProviderProps = {
    // Used for debugging purposes, to identify the provider in the console
    name?: string;
    // Silence the warning about this provider being nested
    silenceIsNestedWarning?: boolean;
};

interface StatsigProps {
    configStore: ConfigStore;
    networkStore: INetworkStore;
    currUser?: User;
    currCompany?: Company;
    overrideUserCustomAttributes?: Record<string, any>;
}

export const HBStatsigProvider = observer(
    ({
        children,
        configStore,
        networkStore,
        currCompany,
        currUser,
        overrideUserCustomAttributes
    }: PropsWithChildren<StatsigProps>) => {
        const providerProps = useStatsigProviderProps({
            currUser,
            configStore,
            networkStore,
            currCompany,
            mountKey: 'static',
            overrideUserCustomAttributes
        });

        return <StatsigProvider {...providerProps}>{children}</StatsigProvider>;
    }
);
